export default "<div class=\"responsive\">\r\n  <cometchat-conversation-list></cometchat-conversation-list>\r\n</div>\r\n";